import { Injectable } from "@angular/core";
import { Message, MessageService } from "primeng/api";

@Injectable({
    providedIn: 'root',
})
export class ToastService {

    constructor(private messageService : MessageService) {}

    add(message : Message) {
        this.messageService.add(message);
    }
}
